import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppSettings } from "@app/common/app-setting";

export interface UnlockUserResponse {
  responseCode: number;
  responseMessage: string;
  data: any;
}

export interface UnlockUserModel {
  userName?: string;
  mobileNumber?: string;
  otp?: string;
}

@Injectable()
export class UnlockUserService {
  _baseurl = `${AppSettings.API_CUSTOMER_ENDPOINT}`;

  constructor(private http: HttpClient) {}

  getUrl(url: string) {
    return this._baseurl + url;
  }
  unlockUser(
    userName: string,
    isUserName: boolean
  ): Observable<UnlockUserResponse> {
    const req = { userName, isUserName };
    return this.http.post<UnlockUserResponse>(
      this.getUrl("v3/prelogin/unlockUser"),
      req
    );
  }

  // Step 2: Send OTP
  sendOtp(mobileNumber: string): Observable<UnlockUserResponse> {
    const formData = new FormData();
    formData.append("mobileNumber", mobileNumber);
    formData.append("source", "forgot");

    return this.http.post<UnlockUserResponse>(
      this.getUrl("v3/prelogin/send-otp"),
      formData
    );
  }

  // Step 3: Verify OTP
  verifyOtp(mobile: string, otp: string): Observable<UnlockUserResponse> {
    debugger;
    const req = new FormData();
    req.append("mobile", mobile);
    req.append("otp", otp);
    return this.http.post<UnlockUserResponse>(
      this.getUrl("v3/prelogin/verify-otp"),
      req
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication/unlock-user.service.ts